var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGuttersAndChimneys(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Illustration",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9,.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18,.cls-19,.cls-20,.cls-21,.cls-22{fill:none;}.cls-2{clip-path:url(#clippath-8);}.cls-3{clip-path:url(#clippath-7);}.cls-4{clip-path:url(#clippath-6);}.cls-5{clip-path:url(#clippath-9);}.cls-6{clip-path:url(#clippath-5);}.cls-7{clip-path:url(#clippath-3);}.cls-8{clip-path:url(#clippath-4);}.cls-9{clip-path:url(#clippath-2);}.cls-10{clip-path:url(#clippath-1);}.cls-23{fill:#006571;}.cls-24{fill:#007c8a;}.cls-25{fill:#fff;}.cls-26{fill:#fff5ef;}.cls-27{fill:#ffd9a2;}.cls-28{fill:#ffe5b8;}.cls-29{fill:#ffd588;}.cls-30{fill:#efefef;}.cls-31{fill:#a2404d;}.cls-32{fill:#b4c2d6;}.cls-33{fill:#8c9cb0;}.cls-34{fill:#bad7f8;}.cls-35{fill:#ced9ea;}.cls-36{fill:#cdd4e0;}.cls-37{fill:#a8baca;}.cls-38{fill:#c6e3e7;}.cls-39{fill:#cfcfcf;}.cls-40{fill:#c4d0de;}.cls-41{fill:#a2b0bf;}.cls-42{fill:#4a9da7;}.cls-11{clip-path:url(#clippath-13);}.cls-12{clip-path:url(#clippath-14);}.cls-13{clip-path:url(#clippath-12);}.cls-14{clip-path:url(#clippath-11);}.cls-15{clip-path:url(#clippath-18);}.cls-16{clip-path:url(#clippath-19);}.cls-17{clip-path:url(#clippath-17);}.cls-18{clip-path:url(#clippath-16);}.cls-19{clip-path:url(#clippath-10);}.cls-20{clip-path:url(#clippath-15);}.cls-21{clip-path:url(#clippath-20);}.cls-22{clip-path:url(#clippath);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "14.42 28.31 68.35 55.36 68.35 91.74 14.42 64.69 14.42 28.31"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "68.35 87.78 68.35 94.74 14.42 67.7 14.42 60.74 68.35 87.78"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m24.38,41.12l11.23,5.54v14.08l-11.23-5.54v-14.08Zm-2.06-3.64v19.3l15.34,7.59v-19.3l-15.34-7.59Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "19.95 36.22 22.33 37.49 22.33 56.94 19.95 58.68 19.95 36.22"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "22.33 56.94 22.33 56.94 37.67 64.53 37.67 67.54 19.95 58.68 22.33 56.94"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "24.38 55.36 35.61 60.9 35.61 46.82 24.38 41.12 24.38 55.36"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "23.91 40.97 25.33 41.6 25.33 54.73 23.91 55.68 23.91 40.97"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "25.33 54.73 25.33 54.73 35.61 59.79 35.61 61.53 23.91 55.68 25.33 54.73"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m49.06,53.62l11.07,5.54v13.92l-11.07-5.54v-13.92Zm-2.06-3.48v19.14l15.18,7.59v-19.14l-15.18-7.59Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "44.47 48.87 47 50.14 47 69.12 44.47 70.86 44.47 48.87"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-10"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "47 69.12 47 69.12 62.19 76.71 62.19 79.72 44.47 71.02 44.47 70.86 47 69.12"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "49.06 67.54 60.13 73.07 60.13 59.16 49.06 53.62 49.06 67.54"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-12"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "48.58 53.46 49.85 54.09 49.85 67.06 48.58 68.01 48.58 53.46"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-13"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "49.85 67.06 49.85 67.06 60.13 72.13 60.13 73.71 48.58 68.01 49.85 67.06"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-14"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "10.15 33.06 64.4 60.1 93.5 28.63 35.77 0 10.15 33.06"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-15"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "64.4 61.84 64.4 60.1 10.15 33.06 10.15 34.32 64.4 61.84"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-16"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "45.26 7.43 40.52 5.06 40.52 12.18 45.26 14.55 45.26 7.43"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-17"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "34.03 19.14 40.52 12.18 40.52 5.06 34.03 8.38 34.03 19.14"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m40.52,5.06l-6.48,3.32,4.75,2.37,6.48-3.32-4.75-2.37Zm0,.95l3.01,1.42-4.75,2.37-3.01-1.42,4.75-2.37Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-19"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "38.78 21.51 34.03 19.14 34.03 8.38 38.78 10.76 38.78 21.51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-20"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "38.78 21.51 45.26 14.55 45.26 7.43 38.78 10.76 38.78 21.51"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gutter_and_eaves"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gutter_eaves"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "93.29 79.84 63.45 97.65 6.7 68.51 39.14 53.37 93.29 79.84"
  }), /*#__PURE__*/React.createElement("g", {
    id: "House_4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-22"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 6.51,
    y: 20.4,
    width: 69.75,
    height: 79.24
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 6.51,
    y: 52.83,
    width: 69.75,
    height: 49.82
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 14.42,
    y: 29.58,
    width: 31.16,
    height: 42.71
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 12.05,
    y: 28.31,
    width: 18.19,
    height: 38.28
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 12.05,
    y: 49.03,
    width: 33.53,
    height: 26.41
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 16.47,
    y: 33.22,
    width: 27.05,
    height: 35.59
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 16,
    y: 33.06,
    width: 17.24,
    height: 30.53
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 16,
    y: 46.82,
    width: 27.52,
    height: 22.62
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 39.09,
    y: 42.23,
    width: 31,
    height: 42.55
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 36.56,
    y: 40.97,
    width: 18.35,
    height: 37.8
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 36.56,
    y: 61.21,
    width: 33.53,
    height: 26.41
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 41.15,
    y: 45.71,
    width: 26.89,
    height: 35.27
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 40.67,
    y: 45.55,
    width: 17.08,
    height: 30.37
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 40.67,
    y: 59.16,
    width: 27.36,
    height: 22.46
  })), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-30",
    cx: 59.5,
    cy: 98.06,
    rx: 3.92,
    ry: 1.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "m62.45,99.13c.61-.34.92-.78.95-1.23l-.02-.03.05-.57c-.27-.26-.57-.5-.89-.7-1.19-.7-3.17-.71-4.4-.02-.32.19-.63.39-.93.6l-.04.58c0,.06,0,.11,0,.17.02.2.08.39.19.57s.25.32.41.44c.09.07.18.13.27.18.48.26,1,.43,1.54.49.98.14,1.99-.02,2.87-.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m62.03,98.32c.5-.27.75-.64.76-1v-.03s-.15-35.12-.15-35.12c0-.05,0-.1-.03-.15-.03-.04-.06-.08-.11-.1-.05-.02-.1-.03-.15-.02-.05,0-.1.03-.14.07-.1.08-.2.15-.31.21l-.14.08c-.23.11-.47.19-.72.24-.88.21-1.8.1-2.61-.3l-.05-.03-.1-.07c-.1-.06-.19-.14-.27-.22-.19-.18-.31-.43-.32-.69v.59s-.01.27-.01.27l.15,35.23v.06c.02.2.1.4.22.56.12.17.28.3.47.39l.05.03c.6.31,1.28.44,1.96.39.47-.02.94-.14,1.37-.34.05,0,.1-.03.14-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m61.89,98.39l-.14-36.15v-.76c.02-.05,0-.11-.02-.15s-.07-.08-.11-.11c-.05-.02-.1-.03-.15-.02-.05,0-.1.03-.14.07-.12.1-.24.19-.38.26-.61.32-1.3.47-2,.45-.24,0-.48-.03-.72-.07-.08-.01-.16-.03-.23-.05-.04-.01-.08-.01-.12,0-.04,0-.08.02-.11.05-.03.02-.06.06-.08.09-.02.04-.03.08-.02.12v.07s.15,35.09.15,35.09v.06c.02.2.1.4.22.56.12.17.28.3.47.39l.05.03c.17.09.34.17.52.22.92.29,1.92.24,2.81-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m59.08,98.55l-.14-35.87v-.7s.01-.07.01-.07c0-.05,0-.11-.03-.16-.03-.05-.07-.09-.12-.11-.05-.02-.11-.03-.16-.02-.05.01-.1.04-.14.08-.09.07-.18.14-.28.2l-.1.06c-.1.06-.2.11-.31.15-.05.02-.09.05-.12.09-.03.04-.04.09-.04.14l.16,34.92v.06c.02.2.1.4.22.56.12.17.28.3.47.39l.05.03c.16.1.34.18.52.24h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m62.32,62.98c.27-.14.5-.33.69-.57.15-.18.24-.41.26-.64v-.5s0-.08-.01-.11c-.02-.04-.04-.07-.07-.09-.25-.22-.51-.42-.8-.6-1.2-.7-3.17-.71-4.4-.02-.29.17-.58.37-.84.58-.03.02-.06.05-.07.09-.02.03-.03.07-.03.11v.46s-.02.07-.02.07c.01.19.07.37.16.53.09.16.22.31.37.42.11.1.24.19.37.26.45.25.94.41,1.44.48,1.01.16,2.05,0,2.96-.46h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m59.03,63.38s.09.01.13,0c.04-.01.08-.03.11-.06.03-.03.06-.07.07-.11.01-.04.02-.08,0-.13-.06-.43-.23-1.11-.44-1.24l-.05-.03c-.3-.16-.63-.27-.97-.33-.04,0-.08,0-.11,0s-.07.03-.1.05c-.03.02-.05.06-.07.09-.02.03-.02.07-.02.11l-.02.83s0,.08.03.12c.02.04.05.07.08.1.08.06.17.12.26.17.35.2.73.33,1.12.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m62.41,59.9c-1.19-.7-3.17-.71-4.4-.02s-1.28,1.82-.08,2.52c1.2.7,3.16.71,4.4.02.89-.5,1.15-1.21.8-1.84-.18-.29-.42-.52-.72-.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "m59.42,98.84c.07.25.13.5.16.76-.54-.06-1.07-.23-1.54-.49-.09-.06-.18-.12-.27-.18,0-.29.01-.59.02-.87.44.13,1.48.79,1.63.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m60.56,62.56c-.73.08-1.47-.05-2.13-.38l-.05-.03c-.45-.28-.69-.62-.7-.97v-.05c.02-.36.28-.72.76-.99.67-.34,1.43-.48,2.19-.39.45.04.89.17,1.28.38l.05.03c.26.14.48.36.61.63.05.11.08.23.08.36,0,.13-.03.26-.08.38-.15.28-.38.5-.67.65-.42.23-.88.36-1.35.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m62.85,98.32c.17-.12.31-.28.41-.46.1-.18.16-.39.17-.59-.02-.21-.08-.41-.19-.59-.11-.18-.25-.34-.43-.45v.61c0,.2,0,.41-.03.61-.13.69-.95,1.04-1.55,1.18-.06.01-.12.03-.19.04-.71.14-1.44.08-2.12-.17-.54-.2-1.11-.6-1.1-1.22l.02-1.05c-.2.13-.36.3-.48.51-.11.21-.17.44-.17.67.04.24.15.48.3.67.15.2.35.36.57.47.52.29,1.11.46,1.71.51.42.04.84.03,1.26-.02.66-.07,1.28-.32,1.81-.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "m61.9,62.16c.26-.14.48-.34.64-.58.02-.04.03-.08.03-.12v-.62s0-.09-.02-.13c-.14-.23-.34-.42-.58-.55l-.05-.03c-.31-.16-.64-.28-.98-.33-.04,0-.08,0-.11,0s-.07.03-.1.05c-.03.02-.05.06-.07.09-.02.03-.02.07-.02.11l-.06,2.21s0,.08.02.12c.02.04.04.07.07.1.03.03.07.04.11.05.04,0,.08.01.12,0,.36-.07.7-.19,1.01-.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    className: "cls-32",
    d: "m58.11,62.35c.08,1.19.63,2.14,1.52,2.46,1.4.5,3.14-.77,3.88-2.82.32-.9.46-1.96.33-2.73l-5.73,3.1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "66.11 60.38 11.67 33.06 6 36 60.38 63.47 66.11 60.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    className: "cls-32",
    d: "m6,36c.08,1.19.63,2.14,1.52,2.46.74.26,1.56.04,2.29-.53.66-.51,1.23-1.31,1.59-2.29.32-.9.4-1.81.27-2.58l-5.67,2.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m10.31,37.47s3.65.75,5.92,3,5.69,2.25,5.69,2.25c0,0,2.24,1.12,5.66,3.37s12.53,4.51,12.53,4.51c0,0,3.67,3.73,10.23,5.63,2.2.64,11.67,6.57,11.67,6.57l-.75,1.88L8.87,38.02s.07-1.3,1.44-.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-3",
    className: "cls-35",
    d: "m7.52,38.46c-.9-.32-1.44-1.27-1.52-2.46l54.38,27.47c.08,1.19.63,2.14,1.52,2.46L7.52,38.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-4",
    className: "cls-32",
    d: "m60.38,63.47c.08,1.19.63,2.14,1.52,2.46,1.4.5,3.14-.77,3.88-2.82.32-.9.46-1.96.33-2.73l-5.73,3.1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "10.15 33.06 64.4 60.1 93.5 28.63 35.77 0 10.15 33.06"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 2.24,
    y: -7.91,
    width: 99.17,
    height: 75.92
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 2.24,
    y: 25.15,
    width: 70.07,
    height: 44.6
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 32.61,
    y: -2.85,
    width: 20.56,
    height: 25.31
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 26.12,
    y: -2.85,
    width: 22.3,
    height: 29.89
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 26.12,
    y: -2.85,
    width: 27.05,
    height: 21.51
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 26.12,
    y: 0.47,
    width: 20.56,
    height: 28.95
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 30.87,
    y: -0.47,
    width: 22.3,
    height: 29.89
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "68.35 94.74 93.24 80.09 93.29 30.5 68.35 57.52 68.35 94.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "64.4 61.84 93.5 30.05 93.5 28.63 64.4 60.1 64.4 61.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "68.35 94.74 68.35 87.78 93.29 74.19 93.29 80.09 68.35 94.74"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuttersAndChimneys);
export default __webpack_public_path__ + "static/media/gutters-and-chimneys.98847c8decde2a3caae56390a09325fe.svg";
export { ForwardRef as ReactComponent };